import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  ICurrentUserModel,
  ILoginResponseModel,
} from '@models/auth/auth.model';
import { StorageService } from './storage.service';
import {
  COOKIE_EXPIRY_DAYS,
  CURRENT_USER,
} from '@core/constants/session.const';
import { IRolePermisssionModel } from '@models/module/module.model';
import { DataHelper, stringAvatar } from '@core/helpers/data.helper';
import { AppModule } from '@core/enums/app-module.enum';
import { UserType } from '@core/enums/type.enum';
import { Routing } from '@core/constants/routing.const';
import { Router } from '@angular/router';

const DASHBOARD_PERMISSIONS = {
  RoleId: 0,
  ModuleName: 'Dashboard',
  Description: 'Dashboard',
  CanManage: true,
  CanView: true,
  CanDelete: true,
};
const MESSAGES_PERMISSIONS = {
  RoleId: 0,
  ModuleName: 'Message',
  Description: 'Messages',
  CanManage: true,
  CanView: true,
  CanDelete: true,
};
const PROFILE_PERMISSIONS = {
  RoleId: 0,
  ModuleName: 'Profile',
  Description: 'Profile',
  CanManage: true,
  CanView: true,
  CanDelete: true,
};

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  IsUserLoggedIn: BehaviorSubject<boolean>;
  rememberMe = false;
  cookieExpiryDays = COOKIE_EXPIRY_DAYS;

  constructor(
    private storageService: StorageService, // private cookieService: CookieService
    private router: Router
  ) {
    this.IsUserLoggedIn = new BehaviorSubject(false);
  }

  private set(val, rememberMe?) {
    if (val) this.IsUserLoggedIn.next(true);
    // const expiryDate: Date = new Date();
    // expiryDate.setDate(expiryDate.getDate() + this.cookieExpiryDays);

    // const encr = EncryptionHelper.hash(CURRENT_USER);
    // const encrVal = EncryptionHelper.encrypt(val);
    // rememberMe &&
    //   this.cookieService.set(encr, encrVal, expiryDate, '/', null, true);
    // !rememberMe && this.cookieService.set(encr, encrVal, null, '/', null, true);
    this.storageService.set(CURRENT_USER, val);
  }

  get() {
    if (this.storageService.get(CURRENT_USER) === null) {
      return null;
    }
    const val = this.storageService.get(CURRENT_USER);
    if (val) this.IsUserLoggedIn.next(true);
    const currentUser = JSON.parse(val);
    return currentUser;
  }

  setCurrentUser(responseBody: ILoginResponseModel) {
    const permissions = this.getRolePermissions(
      responseBody?.permissions,
      responseBody?.userTypeId
    );

    const currentUser: ICurrentUserModel = { ...responseBody, permissions };
    this.set(JSON.stringify(currentUser), false);
  }

  getRolePermissions(permissionStr: string, userTypeId: number) {
    let permissions: Array<IRolePermisssionModel> = DataHelper.IsJsonString(
      permissionStr
    )
      ? JSON.parse(permissionStr)
      : [];
    if (userTypeId === UserType.SuperAdmin) {
      permissions = Object.keys(AppModule)?.map((menu) => {
        return {
          ModuleName: menu,
          CanManage: true,
          CanView: true,
          CanDelete: true,
        };
      });
    } else {
      permissions.push(DASHBOARD_PERMISSIONS);
      permissions.push(MESSAGES_PERMISSIONS);
      permissions.push(PROFILE_PERMISSIONS);
    }
    return permissions;
  }

  getShortName = () => stringAvatar(this.get()?.userName || 'A B');

  getUserName = () => this.get()?.userName;

  setUserName = (userName: string) => {
    const currentUser: ICurrentUserModel = this.get();
    currentUser.userName = userName;
    this.set(JSON.stringify(currentUser), false);
  };

  setProfessionalDescription = (professionalDescription: string) => {
    const currentUser: ICurrentUserModel = this.get();
    currentUser.professionalDescription = professionalDescription;
    this.set(JSON.stringify(currentUser), false);
  };

  logout = async () => {
    this.storageService.remove(CURRENT_USER);
    this.router.navigateByUrl(`/${Routing.Auth}/${Routing.Login}`);
  };
}
